// src/components/HiddenScannerInput.js
// Modal içinde Bluetooth (HID) barkod okuyucu için gizli, otomatik odaklanan TextInput.
// Modal'ın içine yerleştirilir; Modal scene'inde focus aldığı için RN Modal'ın
// arka plandaki sink'e BT eventlarını engelleme problemini aşar.
import React, { useEffect, useRef, useState } from 'react';
import { TextInput, StyleSheet } from 'react-native';

export default function HiddenScannerInput({ active, onScanned }) {
  const ref = useRef(null);
  const [buf, setBuf] = useState('');

  useEffect(() => {
    if (active) {
      const timers = [80, 250, 500].map((d) =>
        setTimeout(() => ref.current?.focus(), d)
      );
      return () => timers.forEach(clearTimeout);
    }
  }, [active]);

  const submit = (raw) => {
    const code = (raw || '').replace(/[\r\n\t]+/g, '').trim();
    setBuf('');
    if (code.length >= 3 && typeof onScanned === 'function') {
      onScanned(code);
    }
  };

  if (!active) return null;

  return (
    <TextInput
      ref={ref}
      value={buf}
      onChangeText={(t) => {
        if (/[\r\n]/.test(t)) submit(t);
        else setBuf(t);
      }}
      onSubmitEditing={(e) => submit(e?.nativeEvent?.text ?? buf)}
      showSoftInputOnFocus={false}
      caretHidden
      submitBehavior="submit"
      autoCorrect={false}
      autoCapitalize="none"
      contextMenuHidden
      style={styles.hidden}
    />
  );
}

const styles = StyleSheet.create({
  hidden: { position: 'absolute', top: -1000, left: -1000, width: 1, height: 1, opacity: 0 },
});
